import { Box } from '@wix/design-system';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useCurrentPage } from '../../../common/hooks/useCurrentPage';
import { selectIsLiveChat, selectIsLocked } from '../../../common/selectors/chat';
import { Page } from '../../../common/types';
import { EndLiveChatButton } from '../EndLiveChatButton';
import { MuteButton } from '../MuteButton';
import { ResetButton } from '../ResetButton';
import { CloseWidget } from './CloseWidget';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import { MessageNotification } from './MessageNotification';

export const HeaderActions: FC = () => {
  const currentPage = useCurrentPage();
  const isChatLocked = useSelector(selectIsLocked);
  const isLiveChat = useSelector(selectIsLiveChat);
  const isChatbotPage = currentPage === Page.Chatbot;

  const endConversationButton: React.ReactElement | null = useMemo(() => {
    if (isChatbotPage) {
      if (isLiveChat) {
        return <EndLiveChatButton isMobileView={true} />;
      } else {
        return (
          <ResetButton
            dataHook={headerActionsDataHooks.resetChatButton()}
            size="small"
            skin="light"
            priority="secondary"
            disabled={isChatLocked}
          />
        );
      }
    }

    return null;
  }, [isChatbotPage, isLiveChat, isChatLocked]);

  return (
    <Box gap={1}>
      {endConversationButton}
      {isLiveChat && <MuteButton />}
      <MessageNotification />
      <CloseWidget />
    </Box>
  );
};
